import { Attributes, ModelBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class FileImportProcessStatusModel extends ModelBase {
    
    @Attributes.Date()
    public dateReport: Date | null = null;

    public fileName: string = "";

    public fileImportStatus: string = "";

    public rawFileImport: string = "";

    public normalisation: string = "";

    public extraction: string = "";

    public interception: string = "";

    public numberOfRecords: number | null = null;

    public lastUpdate: string = "";

    public rawImportFileID: number = 0;
}